import { apiRequest } from './client'
import type { ApiTaxon } from './types'

export function listTaxons(activeOnly = true): Promise<ApiTaxon[]> {
  return apiRequest<ApiTaxon[]>('/taxons', {
    query: { activeOnly },
  })
}

export function listRootTaxons(): Promise<ApiTaxon[]> {
  return apiRequest<ApiTaxon[]>('/taxons/roots')
}
